import {
  WalletsPlansClient,
  PurchasePlan,
  FiatCurrency,
  PurchasePlanList,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";
import { SPECIAL_OFFER_MARKER } from "../utils/constants";
import { handleGetProfile } from "./userAccountClient";

interface HandleGetPurchasePlansData {
  allPlans: PurchasePlan[];
  specialOfferPlans: PurchasePlan[];
}

const walletsPlansClient = new WalletsPlansClient(
  apiConfig,
  undefined,
  axiosInstance
);

const checkHasSpecialOfferPlans = (plan: PurchasePlan): boolean =>
  plan.metadata !== undefined &&
  plan.metadata.length > 0 &&
  !!plan.metadata.find((e) => e.name === SPECIAL_OFFER_MARKER);

const handleGetPurchasePlans = async (
  currency?: FiatCurrency
): Promise<HandleGetPurchasePlansData | undefined> => {
  try {
    const userCurrency = currency || (await handleGetProfile())?.currency;
    if (!userCurrency) return;

    const allPlans = (
      await walletsPlansClient.listHprPurchasePlans(
        undefined,
        undefined,
        undefined,
        userCurrency as FiatCurrency
      )
    ).data.records;
    const specialOfferPlans = allPlans.filter(checkHasSpecialOfferPlans);
    return {
      allPlans,
      specialOfferPlans,
    };
  } catch {
    return;
  }
};

const handleGetHprPurchasePlans = async (): Promise<
  PurchasePlanList | undefined
> => {
  const data = (await walletsPlansClient.listHprPurchasePlans()).data;
  return data;
};

export { handleGetPurchasePlans, handleGetHprPurchasePlans };
